module.exports = __webpack_public_path__ + "static/media/img_snake_body_vertical.e00f18dd.svg";